
import { FaInstagram, FaFacebook, FaYoutube, FaLinkedinIn, FaTiktok, FaWhatsapp, FaTelegram, FaPinterest, FaSpotify } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { useNavConfig, type SocialNetwork } from "@/hooks/useNavConfig";

export const SOCIAL_META: Record<SocialNetwork, {
  label: string;
  icon: React.ElementType;
  color: string;
}> = {
  instagram: { label: "Instagram", icon: FaInstagram, color: "hover:bg-gradient-to-br hover:from-purple-500 hover:via-pink-500 hover:to-orange-400" },
  facebook:  { label: "Facebook",  icon: FaFacebook,  color: "hover:bg-[#1877F2]" },
  youtube:   { label: "YouTube",   icon: FaYoutube,   color: "hover:bg-[#FF0000]" },
  linkedin:  { label: "LinkedIn",  icon: FaLinkedinIn,color: "hover:bg-[#0A66C2]" },
  x:         { label: "X",         icon: FaXTwitter,  color: "hover:bg-[#000000]" },
  tiktok:    { label: "TikTok",    icon: FaTiktok,    color: "hover:bg-[#010101]" },
  whatsapp:  { label: "WhatsApp",  icon: FaWhatsapp,  color: "hover:bg-[#25D366]" },
  telegram:  { label: "Telegram",  icon: FaTelegram,  color: "hover:bg-[#2AABEE]" },
  pinterest: { label: "Pinterest", icon: FaPinterest, color: "hover:bg-[#E60023]" },
  spotify:   { label: "Spotify",   icon: FaSpotify,   color: "hover:bg-[#1DB954]" },
};

export function SocialLinks() {
  const { socialLinks } = useNavConfig();
  const visible = socialLinks.filter(s => s.enabled && s.url && s.url !== '#');

  return (
    <div className="flex flex-wrap gap-3">
      {visible.map((social) => {
        const meta = SOCIAL_META[social.network];
        if (!meta) return null;
        const Icon = meta.icon;
        return (
          <a
            key={social.id}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={meta.label}
            className={`w-10 h-10 rounded-xl bg-white/10 border border-white/20 text-white flex items-center justify-center transition-all duration-300 hover:scale-110 hover:border-transparent ${meta.color}`}
          >
            <Icon size={18} />
          </a>
        );
      })}
    </div>
  );
}
